import { render, staticRenderFns } from "./MainRightMenu.vue?vue&type=template&id=6b443f8c&scoped=true&"
import script from "./MainRightMenu.vue?vue&type=script&lang=js&"
export * from "./MainRightMenu.vue?vue&type=script&lang=js&"
import style0 from "./MainRightMenu.vue?vue&type=style&index=0&id=6b443f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b443f8c",
  null
  
)

export default component.exports